import React from "react"

import { getCxFromStyles } from "../../helpers"

import * as styles from "./Partner.module.scss"
import reasonChart from "../../assets/reason-chart.png"

const Partner: React.FC = () => {
  const cx = getCxFromStyles(styles)

  return (
    <>
      <div className={cx("image")}>
        <img
          src={reasonChart}
          alt="Chart illustrating reasons to partner with Rate Cleaner"
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className={cx("root")}>
        <div className={cx("content")}>
          <h2>
            Reasons to
            <br /> partner with us
          </h2>
          <ul>
            <li>Increase booking revenues</li>
            <li>Minimise costly errors</li>
            <li>Resolve issues faster</li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Partner
